import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";

import Map from "./components/Map";
import { GlobalStyle } from "./style/theme";

import "../node_modules/tachyons/css/tachyons.css";
import "./App.css";

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <GlobalStyle />
        <Router>
          <Switch>
            <Route exact path="/:configId/:spotLayer?/:spotId?" component={Map} />
          </Switch>
        </Router>
      </Provider>
    );
  }
}

export default App;
